import React from "react";
import { Container } from "reactstrap";
import LeftSideRibbons from "./LeftSideRibbons";
import RightSideRibbon from "./RightSideRibbon";
import { Breadcrumbs } from "../../../AbstractElements";
import { BonusUi, RibbonsTitle } from "../../../Constants/Constants";

const RibbonsContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={RibbonsTitle} parent={BonusUi} />
      <Container fluid>
        <LeftSideRibbons />
        <RightSideRibbon />
      </Container>
    </>
  );
};
export default RibbonsContainer;
